import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useRouter } from "next/router";
import { useCookie } from "utils/cookieHelper";
import { Box } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useFormatMessage } from "components/base/Trans";
import Select from "components/base/Select";

const MotionSelect = motion(Select);

const LanguageSelector = ({ small, cookie: cookieProp, color, ...rest }) => {
  const formatMessage = useFormatMessage();
  const router = useRouter();
  const { locale, defaultLocale, asPath } = router;
  const cookie = useCookie(cookieProp);

  const labels = small
    ? {
        en: "en",
        ru: "ru",
        pt: "pt",
        es: "es",
        it: "it",
        fr: "fr",
        de: "de",
      }
    : {
        en: formatMessage({ id: "LBL_LANGUAGE_ENGLISH" }),
        ru: formatMessage({ id: "LBL_LANGUAGE_RUSSIAN" }),
        pt: formatMessage({ id: "LBL_LANGUAGE_PORTUGUESE" }),
        es: formatMessage({ id: "LBL_LANGUAGE_ESPANOL" }),
        it: formatMessage({ id: "LBL_LANGUAGE_ITALIAN" }),
        fr: formatMessage({ id: "LBL_LANGUAGE_FRENCH" }),
        de: formatMessage({ id: "LBL_LANGUAGE_GERMAN" }),
      };
  const { watch, control, setValue } = useForm({
    defaultValues: { language: locale || defaultLocale || "en" },
  });
  const watchLanguage = watch("language");

  const placeholderLabel =
    {
      ru: labels.ru,
      "pt-br": labels.pt,
      "es-la": labels.es,
      en: labels.en,
      it: labels.it,
      fr: labels.fr,
      de: labels.de,
    }[watchLanguage] ?? labels.en;

  useEffect(() => {
    if (locale !== watchLanguage) {
      router.push(asPath, asPath, { locale: watchLanguage });
      cookie.set("NEXT_LOCALE", watchLanguage, { expires: 365, path: "/" });
    }
  }, [watchLanguage]);

  useEffect(() => {
    setValue("language", locale);
  }, [locale]);

  return (
    <Box _hover={{ opacity: 0.7 }} transition="all 0.2s ease-out">
      <Controller
        name="language"
        control={control}
        as={MotionSelect}
        color={color || "white"}
        placeholder={placeholderLabel}
        iconColor={color || "white"}
        fontWeight="bold"
        aria-label="language"
        fontSize="12px"
        textTransform="uppercase"
        iconSize="24px"
        letterSpacing="4px"
        variant="unstyled"
        style={{
          width: small ? "56px" : "150px",
        }}
        _hover={{ cursor: "pointer" }}
        {...rest}
      >
        {watchLanguage !== "en" && <option value="en">{labels.en}</option>}
        {watchLanguage !== "es-la" && (
          <option value="es-la">{labels.es}</option>
        )}
        {watchLanguage !== "pt-br" && (
          <option value="pt-br">{labels.pt}</option>
        )}
        {watchLanguage !== "it" && <option value="it">{labels.it}</option>}
        {watchLanguage !== "fr" && <option value="fr">{labels.fr}</option>}
        {watchLanguage !== "de" && <option value="de">{labels.de}</option>}
        {watchLanguage !== "ru" && <option value="ru">{labels.ru}</option>}
      </Controller>
    </Box>
  );
};
export default LanguageSelector;
